import React, { FC } from 'react';
import { useEditorContext } from '../../../../components/Editor/Context';
import cn from 'classnames';
import Alignment from '../buttons/Alignment';
import Delete from '../buttons/Delete';
import BlockBubbleMenu from '../../../../components/menus/BlockBubbleMenu';
import { DaGifOptions } from '../../gif';
import {
  getExtensionOptions,
  shouldBlockMenuBeOpen,
} from '../../../../components/utils/tiptap';
import { isTouch } from '../../../../components/utils/browser';
import Edit from '../buttons/Edit';
import { EXTENSION_TYPE_NAME } from '../../constants';

export interface Props {
  scrollContainerRef?: React.RefObject<HTMLElement | null>;
}

const MenuButtons: FC<any> = ({ editor, forMobile = false }) => {
  const options: DaGifOptions = getExtensionOptions(
    editor,
    EXTENSION_TYPE_NAME
  );
  return (
    <div
      className={cn(!forMobile && 'ds-surface-tertiary')}
      style={{ maxWidth: '100vw', display: 'flex', flexWrap: 'wrap' }}
    >
      {options.canAlign && <Alignment editor={editor} />}
      <Edit editor={editor} />
      <Delete editor={editor} />
    </div>
  );
};

const DaGifBubbleMenu: FC<Props> = ({ scrollContainerRef }) => {
  const editor = useEditorContext();

  if (!editor) {
    return null;
  }

  if (!editor?.isEditable || isTouch()) {
    return null;
  }

  const open = shouldBlockMenuBeOpen(editor, EXTENSION_TYPE_NAME);

  const options: DaGifOptions = getExtensionOptions(
    editor,
    EXTENSION_TYPE_NAME
  );
  let buttonCount = 3;
  if (!options.canAlign) {
    buttonCount--;
  }

  return (
    <BlockBubbleMenu
      scrollContainerRef={scrollContainerRef}
      menuHeight={38}
      menuWidth={40 * buttonCount}
      editor={editor}
      open={open}
      childSelector="video"
    >
      <MenuButtons editor={editor} />
    </BlockBubbleMenu>
  );
};
DaGifBubbleMenu.displayName = 'DaGifBubbleMenu';

export default DaGifBubbleMenu;
export { MenuButtons };
